<template>
  <div class="swiper_bg">
    <div class="middle_banner">
      <div class="swiper-button-prev swiper-button-prev1">
        <img src="../../../static/img/资源45.png" class="bannerleft" />
      </div>
      <div class="swiper-container mySwiper mySwiper1" id="mySwiper1">
        <div class="swiper-wrapper">
          <!-- Slides -->
          <!-- <div class="swiper-slide" v-for="(item, index) in List" :key="index"> -->
          <div class="swiper-slide" v-for="(item, index) in zzry" :key="index">
            <!-- <img src="../../static/img/3A证书.png" /> -->
            <img class="book1_img" :src="item.img" />
          </div>
        </div>
      </div>
      <div class="swiper-button-next swiper-button-next1">
        <img src="../../../static/img/资源452.png" class="bannerright" /> -->
      </div>
    </div>
    <p class="swiper_title">{{ bannertext }}</p>
  </div>
</template>
<script>
export default {
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  watch: {
    //监听轮播数据变化后再创建实例
    zzry() {
      this.$nextTick(() => {
        let that = this;
        new Swiper(".mySwiper1", {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          autoplay: {
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
          },
          on: {
            activeIndexChange: function () {
              //alert("改变了，activeIndex为" + this.activeIndex);
              console.log("改变了，activeIndex为" + this.activeIndex)
            },
            slideChange: function(){
              console.log("slideChange==" + this.activeIndex)
              console.log("slideChange real==" + this.realIndex)
              that.changetext(this.realIndex)
            },
          },
        });
      });
    },
  },
  data() {
    return {
      bannertext: "",
      zzry: [],
    };
  },
  mounted() {
    this.getInfo();
  },
  beforeDestroy() {},
  created() {},
  methods: {
    getInfo() {
      this.$http.get("hdbs/api/publicity/honor/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            var list = response.data.page.list;
            this.zzry = list;
            this.bannertext =
              this.language == "zh" ? this.zzry[0].title : this.zzry[0].titleEn;
          }
          // this.initSwiper();
        }.bind(this)
      );
    },
    changetext(i) {
      // var position = i-(this.zzry.length-1);
      // if(position<0||position>=this.zzry.length){
        //   position = 0;
      // }
      var position = i;
      console.log('position=='+position)
      this.bannertext =
        this.language == "zh" ? this.zzry[position].title : this.zzry[position].titleEn;
    },
  },
};
</script>
<style lang="stylus" scoped>
.book1_img {
  width: 100% !important;
  height: 47rem;
  object-fit: contain;
}

.swiper_bg {
  // margin: 5rem 0;
  // padding: 3rem 0;
}

.swiper_title {
  margin: 5rem 0 0;
  font-family: Demibold;
  font-size: 2rem;
  color: var(--mainBlue);
  text-align: center;
}

.bannerright {
  width: 8rem;
  cursor: pointer;
  z-index: 99;
  padding: 5rem 3rem;
  border-radius: 6px;
}

.bannerleft {
  width: 8rem;
  cursor: pointer;
  z-index: 99;
  padding: 5rem 3rem;
  border-radius: 6px;
}

.bannerleft:hover, .bannerright:hover {
  background: rgba(0, 0, 0, 0.05);
}

.swiper-button-prev {
  // background-image: url('../../../static/img/资源45.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 10rem;
  height: 10rem;
  // margin-left: 10rem;
  outline: none;
}

.swiper-button-prev:hover {
  // background-image: url('../../static/img/bannerlefthover.png');
}

.swiper-button-next {
  // background-image: url('../../../static/img/资源452.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 10rem;
  height: 10rem;
  // margin-right: 10rem;
  outline: none;
}

.swiper-button-next:hover {
  // background-image: url('../../static/img/bannerrighthover.png');
}

.mySwiper {
  width: 100%;
  // margin: 3rem 8rem;
}

.middle_banner {
  width: 70vw;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
}

.swiper-slide {
  width: 30vw;
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.7);

  img {
    // width: 40rem;
    // height: 25rem;
  }
}

.swiper-slide-active, .swiper-slide-duplicate-active {
  transform: scale(1);
}
@media screen and (max-width: 1200px) {
  .middle_banner{
    width:100%;
  }
  .swiper-button-prev{
    display: none;
    //width:auto;
    //left:1px;
  }
  .swiper-button-next{
    display: none;
    //width:auto;
    //right:1px;
  }
  .bannerleft{
    width:1rem;
    padding:0;
  }
  .bannerright{
    width:1rem;
    padding:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/MySwiper.vue